<template>
  <div>
    <div v-if="submitted" class="alert alert-success" role="alert">
      Deine Nachricht wurde gesendet.
    </div>
    <resource
      v-else
      resource="adminSupportMessage"
      notification="Nachricht wurde gesendet"
      @resource-persisted="submitted = true"
      :attributes="[
        {
          name: 'moderator_id',
          label: 'ID',
          type: 'StaticText',
          value: this.moderatorId
        },
        {
          name: 'copy_to_agency_leader',
          label: 'Kopie an Agenturleitung',
          type: 'CheckboxSelector',
          value: false
        },
        {
          name: 'message',
          label: 'Nachricht',
          type: 'TextareaSelector'
        }
      ]"
    >
      <div v-if="!noTitle" slot="title">
        <h4>Moderator kontaktieren</h4>
      </div>
    </resource>
  </div>
</template>

<script>
export default {
  props: ["moderatorId", "noTitle"],
  data() {
    return {
      submitted: false
    };
  }
};
</script>
